import { authGet } from './authMiddleware';

export const getPortfolio = async () => {
    return authGet('/api/Portfolio');
}